import React from 'react';
import moment from 'moment';
import { Alert, FormGroup, Input } from 'reactstrap';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import {
    FormLabel,
    ValidationErrorMessage,
} from '../common/forms/FormElements';
import { MomentDateFormat } from '../MomentDateFormat';
import { toEmployeeString } from './LongTermSchedule';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import CrewDisplayButton from './CrewDisplayButton';

export default class LongTermSchedleBasicDetails extends React.Component {
    getCrewName = () => {
        const { longTermSchedule, crews } = this.props;
        const publishedCrewName = longTermSchedule.publishedCrew?.name;
        const adHocCrewName = longTermSchedule.adHocCrewName;

        if (publishedCrewName?.trim()) {
            return publishedCrewName;
        }

        if (adHocCrewName?.trim()) {
            return adHocCrewName;
        }

        return (
            crews.find((c) => c.id == longTermSchedule.crewId)?.name ?? ''
        );
    };

    render() {
        const {
            contracts,
            longTermSchedule,
            companies,
            showNonFolinoContracts,
            crews,
            employees,
            neitherCrewNorEmployeeSet,
            isReleased,
            isCancelled,
            maxCrewEndDate,
            onChange,
            onCrewChange,
            onContractChange,
            crewIsAdHoc,
            availableLeadEmployees,
            leadEmployee,
            onLeadEmployeeChange,
            arcGisLocations,
            loadingSupplementalData,
            schedulers,
            onProjectManagerChange,
            superintendents,
            onSuperintendentChange,
        } = this.props;

        const crewName = this.getCrewName();

        return (
            <>
                <div className="d-flex lts-basic-details">
                    <FormGroup className="col-xl-6">
                        <FormLabel
                            htmlFor="longTermSchedule.contractId"
                            text="Job"
                            required={true}
                        />
                        <ValidatedSelect
                            id="longTermSchedule.contractId"
                            name="longTermSchedule.contractId"
                            options={contracts.filter(
                                (c) =>
                                    (c.contractStatusId == 1 ||
                                        longTermSchedule.contractId == c.id) &&
                                    (showNonFolinoContracts ||
                                        c.companyId == 3 ||
                                        companies.find(
                                            (co) =>
                                                co.id == c.companyId &&
                                                co.parentCompanyId == 3
                                        ))
                            )}
                            getOptionValue={(c) => c.id}
                            getOptionLabel={(c) => {
                                const company = companies.find(
                                    (co) => co.id == c.companyId
                                );

                                const parentCompany = companies.find(
                                    (co) => co.id == company.parentCompanyId
                                );

                                const inactive =
                                    c.contractStatusId != 1
                                        ? ' (Inactive)'
                                        : '';

                                const parentCompanyIndicator =
                                    !parentCompany || parentCompany.id == 3
                                        ? ''
                                        : `[${parentCompany.companyName}] `;

                                return `${parentCompanyIndicator}${c.number} - ${c.description} - (${company.companyName})${inactive}`;
                            }}
                            value={
                                contracts.filter(
                                    (c) => longTermSchedule.contractId == c.id
                                ) ?? ''
                            }
                            onChange={onContractChange}
                            disabled={longTermSchedule.isPublished}
                            readOnly={longTermSchedule.isPublished}
                        />
                        <ValidationErrorMessage>
                            Contract selection is required.
                        </ValidationErrorMessage>

                        {/* bugbug: this is trivially working, but needs some further logic to flip it to true when loading an LTS for a non-Folino contract */}
                        {/* <FormCheckbox
                        className="mt-2"
                        name="showNonFolinoContracts"
                        onChange={this.onChange}
                        checked={showNonFolinoContracts}
                        labelText="Include jobs for TDF / CARD"
                    /> */}

                        {Boolean(
                            !loadingSupplementalData &&
                            longTermSchedule.contractId &&
                            (!arcGisLocations || arcGisLocations.length == 0)
                        ) && (
                            <Alert
                                className="mt-2"
                                color="warning"
                                fade={false}
                            >
                                <FontAwesomeIcon
                                    icon={faWarning}
                                    className="mr-2"
                                />
                                There is no GIS location data for this job.
                            </Alert>
                        )}
                    </FormGroup>

                    <FormGroup className="col-xl-6">
                        <FormLabel
                            htmlFor="longTermSchedule.crewId"
                            text="Crew"
                        />

                        {longTermSchedule.isPublished ? (
                            <Input
                                id="longTermSchedule.crewId"
                                name="longTermSchedule.crewId"
                                type="text"
                                value={crewName}
                                disabled={true}
                            />
                        ) : (
                            <Select
                                id="longTermSchedule.crewId"
                                name="longTermSchedule.crewId"
                                options={crews.filter(
                                    (c) =>
                                        !c.isInactive ||
                                        c.crewId == longTermSchedule.crewId
                                )}
                                getOptionValue={(c) => c.id}
                                getOptionLabel={(c) =>
                                    c.isInactive
                                        ? `${c.Name} (Inactive)`
                                        : c.name
                                }
                                value={
                                    crews.filter(
                                        (c) =>
                                            longTermSchedule.crewId == c.id
                                    ) ?? ''
                                }
                                onChange={onCrewChange}
                                required={false}
                                isClearable={true}
                                defaultValue=""
                            />
                        )}

                        <CrewDisplayButton {...this.props} />

                        {neitherCrewNorEmployeeSet && (
                            <small className="text-danger">
                                Please select either a crew or a lead employee.
                            </small>
                        )}
                    </FormGroup>
                </div>

                <div className="d-flex">
                    <FormGroup className="col-xl-4">
                        <FormLabel
                            htmlFor="longTermSchedule.projectManagerId"
                            text="Project Manager"
                            required
                        />
                        <ValidatedSelect
                            id="longTermSchedule.projectManagerId"
                            name="longTermSchedule.projectManagerId"
                            options={schedulers}
                            getOptionValue={(e) => e.id}
                            getOptionLabel={(e) =>
                                `${e.lastName}, ${e.firstName}`
                            }
                            value={
                                employees.find(
                                    (e) =>
                                        e.id ==
                                        longTermSchedule.projectManagerId
                                ) ?? ''
                            }
                            onChange={onProjectManagerChange}
                            disabled={longTermSchedule.isPublished}
                        />
                        <ValidationErrorMessage>
                            Project manager selection is required.
                        </ValidationErrorMessage>
                    </FormGroup>

                    <FormGroup className="col-xl-4">
                        <FormLabel
                            htmlFor="longTermSchedule.superintendentId"
                            text="Superintendent"
                        />
                        <ValidatedSelect
                            id="longTermSchedule.superintendentId"
                            name="longTermSchedule.superintendentId"
                            options={superintendents}
                            getOptionValue={(e) => e.id}
                            getOptionLabel={(e) =>
                                `${e.lastName}, ${e.firstName}`
                            }
                            value={
                                employees.find(
                                    (e) =>
                                        e.id ==
                                        longTermSchedule.superintendentId
                                ) ?? ''
                            }
                            onChange={onSuperintendentChange}
                            disabled={longTermSchedule.isPublished}
                        />
                    </FormGroup>

                    <FormGroup className="col-xl-4">
                        <FormLabel
                            htmlFor="longTermSchedule.leadEmployeeId"
                            text="Lead"
                        />
                        <ValidatedSelect
                            id="longTermSchedule.leadEmployeeId"
                            name="longTermSchedule.leadEmployeeId"
                            options={availableLeadEmployees}
                            getOptionValue={(e) => e.id}
                            getOptionLabel={(e) => toEmployeeString(e)}
                            value={
                                employees.find(
                                    (e) => e.id == leadEmployee.id
                                ) ?? ''
                            }
                            onChange={onLeadEmployeeChange}
                            disabled={longTermSchedule.isPublished}
                        />
                        <ValidationErrorMessage>
                            Crew selection is required.
                        </ValidationErrorMessage>
                    </FormGroup>
                </div>

                {crewIsAdHoc && (
                    <FormGroup>
                        <FormLabel text="Ad Hoc Crew Name" />

                        <Input
                            id="longTermSchedule.adHocCrewName"
                            name="longTermSchedule.adHocCrewName"
                            value={longTermSchedule.adHocCrewName}
                            onChange={onChange}
                            type="text"
                            disabled={isReleased || isCancelled}
                            maxLength={80}
                        />
                    </FormGroup>
                )}

                {maxCrewEndDate &&
                    moment(maxCrewEndDate).isBetween(
                        longTermSchedule.startDate,
                        longTermSchedule.endDate,
                        'day',
                        '[]'
                    ) && (
                        <Alert color="info" fade={false}>
                            This crew is attached to jobs out through{' '}
                            {moment(maxCrewEndDate).format(
                                MomentDateFormat.WeekDayNameAndDate
                            )}
                            .
                        </Alert>
                    )}
            </>
        );
    }
}
